(function () {
  document.addEventListener(
    'click',
    function (e) {
      const anchor = e.target.closest('a[href]');
      if (!anchor) return;

      const href = anchor.getAttribute('href') || '';

      // Only act on hash-only links: href="#something"
      // Also handle full same-page links: href="/current-path#something"
      let isSamePageHash = false;
      if (href.charAt(0) === '#' && href.length > 1) {
        isSamePageHash = true;
      } else if (href.indexOf('#') > 0) {
        try {
          const url = new URL(href, window.location.href);
          isSamePageHash =
            url.origin === window.location.origin && url.pathname === window.location.pathname;
        } catch (_) {}
      }

      if (!isSamePageHash) return;

      const pt = document.querySelector('page-transition');
      if (pt && typeof pt.markNextNavigationAsProgrammatic === 'function') {
        pt.markNextNavigationAsProgrammatic();
      }
    },
    { capture: true }
  );
})();
